var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReCampaignTriggered = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.25C16.9068 0.25 21.7011 5.01385 21.75 10.9092C21.7534 11.3234 21.4201 11.6626 21.0059 11.666C20.5917 11.6694 20.2535 11.336 20.25 10.9219C20.208 5.84934 16.0825 1.75 11 1.75C5.89137 1.75 1.75 5.89137 1.75 11C1.75 16.0825 5.84934 20.208 10.9219 20.25C11.336 20.2535 11.6694 20.5917 11.666 21.0059C11.6626 21.4201 11.3234 21.7534 10.9092 21.75C5.01385 21.7011 0.25 16.9067 0.25 11C0.25 5.06294 5.06294 0.25 11 0.25ZM11.0576 12.4238C10.7762 11.5794 11.5794 10.7762 12.4238 11.0576L20.2617 13.6699C21.2462 13.9983 21.2463 15.3914 20.2617 15.7197L17.3672 16.6836C17.0447 16.7911 16.7911 17.0447 16.6836 17.3672L15.7197 20.2617C15.3914 21.2463 13.9983 21.2462 13.6699 20.2617L11.0576 12.4238ZM11 5.25C13.4157 5.25 15.4815 6.73977 16.333 8.84766C16.488 9.23159 16.3028 9.66801 15.9189 9.82324C15.5349 9.97839 15.0975 9.79324 14.9424 9.40918C14.312 7.84882 12.7835 6.75 11 6.75C8.65279 6.75 6.75 8.65279 6.75 11C6.75 12.7835 7.84882 14.312 9.40918 14.9424C9.79324 15.0975 9.97839 15.5349 9.82324 15.9189C9.66801 16.3028 9.23159 16.488 8.84766 16.333C6.73977 15.4815 5.25 13.4157 5.25 11C5.25 7.82436 7.82436 5.25 11 5.25Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReCampaignTriggered);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_Campaign_Triggered.c4d9cea48dd554f21ffe4b68a0f1bfef.svg";